<p-confirmDialog #salesforceAccountCD [style]="{width: 'fit-content', paddingBottom : '1%'}"
                 header="Confirm account change"
                 key="salesforceAccountCD">
  <ng-template pTemplate="footer">
    <button (click)="salesforceAccountCD.accept()" class="btn btn-outline-danger button-size pull-right" type="reset">
      <i aria-hidden="true" class="fa fa-check pr-2"></i>
      Confirm
    </button>
    <button (click)="salesforceAccountCD.reject()" class="btn btn-outline-success button-size pull-right" type="reset">
      <i aria-hidden="true" class="fa fa-times pr-2"></i>
      Cancel
    </button>
  </ng-template>
</p-confirmDialog>
<div id="iframe-portalV1">
  <div class="layout-main">
    <div class="container-fluid">
      <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
        <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
          <ol *ngIf="!loading" class="breadcrumb ol-sf-1">
            <li class="breadcrumb-item">
              <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company?.uniqid}}">Home</a>
              <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company?.uniqid}}">Home</a>
            </li>
            <li class="breadcrumb-item">
              <a routerLink="/{{getUserCurrent().company?.uniqid}}/company">List companies</a>
            </li>
            <li *ngIf="isEditPage() || isShowPage()" aria-current="page" class="breadcrumb-item active">
              {{ currentCompany.name }}
            </li>
            <li *ngIf="isAddPage()" aria-current="page" class="breadcrumb-item active">
              New
            </li>
          </ol>
        </nav>
      </nav>
      <div *ngIf="!hasPermission() || accessDenied" class="mb-3">
        You don't have the required permission to access this page.
      </div>
      <div *ngIf="!loading">
        <div *ngIf="hasPermission() && !accessDenied">
          <div class="pb-2 mb-3 border-bottom">
            <h3 *ngIf="isShowPage()">
              <b>{{ currentCompany.sugarShortname }} ({{ currentCompany.name }}) </b>
              <span class="badge badge-info badge-client">{{ parseClientFromMckayAndOrQuincy() }}</span>
              <span *ngIf="currentCompany && currentCompany.timeSyncOnly" class="badge badge-danger badge-client ml-1">Precision Time Exchange view only</span>
            </h3>
            <h3 *ngIf="isEditPage()">
              <b>Edit {{ currentCompany.name }} </b>
              <span class="badge badge-info badge-client">{{ parseClientFromMckayAndOrQuincy() }}</span>
              <span *ngIf="currentCompany && currentCompany.timeSyncOnly" class="badge badge-danger badge-client ml-1">Precision Time Exchange view only</span>
            </h3>
            <h3 *ngIf="isAddPage()"><b>New Company</b></h3>
          </div>
          <p-messages [value]="msgsAws"></p-messages>
          <div *ngIf="error"
               class="alert alert-danger alert-dismissible fade show" id="process_request_error_alert">
            <span *ngIf="error">{{ errorMessage }}</span>
            <a *ngIf="error && existingUserLink" [href]="existingUserLink" target="_blank" rel="noopener"> Click here to view the existing user. <i class="fa fa-external-link" aria-hidden="true"></i></a>
            <button (click)="error = false" aria-label="Close"
                    class="close"
                    type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div *ngIf="successDelete" class="alert alert-success alert-dismissible fade show">
            Billing account has been deleted.
            <button (click)="successDelete = false" aria-label="Close" class="close" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ng-container *ngIf="!error">
            <div *ngIf="successAdd && isAddPage() || successEdit && isEditPage()"
                 class="alert alert-success alert-dismissible fade show">
              <span *ngIf="successAdd && isAddPage()">The client was created successfully.</span>
              <span *ngIf="successEdit && isEditPage()">The client was updated successfully.</span>
              <button (click)="successAdd = false; successEdit = false" aria-label="Close" class="close" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </ng-container>
          <div *ngIf="alertNoChange && isEditPage()" class="alert alert-warning alert-dismissible fade show">
            Modify at least <strong>one</strong> field
            <button (click)="alertNoChange = false" aria-label="Close" class="close" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div *ngIf="isAddPage()" class="alert alert-info" role="alert">
            Please note that:
            <ul class="mb-0">
              <li>Shortname should match an account shortname in Salesforce.</li>
              <li>Creating a new company will automatically send an email to its primary contact.</li>
              <li>Information for this company are updated approx every 30 minutes.</li>
            </ul>
          </div>
          <div *ngIf="isShowPage() ||isEditPage()" class="alert alert-info" role="alert">
            Please note that:
            <ul class="mb-0">
              Changes in this page will not trigger any email.
            </ul>
            <ul class="mb-0">
              Dad reporting settings are enabled depending on client's market data consumption.
            </ul>
            <ul class="mb-0">
              A Portal company must be tied to a Salesforce account:
              <ul>
                <li><strong> Send To Portal</strong> must be checked in Salesforce</li>
              </ul>
            </ul>
            <ul class="mb-0">
              A Portal company should be tied to the <strong> Global account </strong> if it exists in Salesforce, a
              <strong> legal entity</strong> without a parent company if there is no Global account.
            </ul>
          </div>
          <div *ngIf="isShowPage() && hasActionSection()" class=pb-4>
            <p-panel [toggleable]="true">
              <ng-template pTemplate="header">
                <span class="filter-title p-panel-title"><i class="fa fa-list"></i> Actions</span>
              </ng-template>
              <div class="row pt-2">
                <div *ngIf="hasQEDButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary  "
                    name="qed_profile_link"
                    routerLink="/{{companyUniqid}}/quincyClientProfile/qed" type="button">
                    <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                    <span> Snapshot (QED) profile</span>
                  </button>
                </div>
                <div *ngIf="hasQRDButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary "
                    name="qrd_profile_link"
                    routerLink="/{{companyUniqid}}/quincyClientProfile/qrd" type="button">
                    <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                    <span> QRD profile</span>
                  </button>
                </div>
                <div *ngIf="hasQFDButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary "
                    name="qfd_profile_link"
                    routerLink="/{{companyUniqid}}/quincyClientProfile/qfd" type="button">
                    <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                    <span> QFD profile</span>
                  </button>
                </div>
                <div *ngIf="hasQHFButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary"
                    name="qhf_profile_link"
                    routerLink="/{{companyUniqid}}/quincyClientProfile/qhf" type="button">
                    <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                    <span> QHF profile</span>
                  </button>
                </div>
                <div *ngIf="hasNewsButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary"
                    name="news_profile_link"
                    routerLink="/{{companyUniqid}}/quincyClientProfile/news" type="button">
                    <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                    <span> News profile</span>
                  </button>
                </div>
                <div *ngIf="hasLOAsButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary "
                    name="LOAs"
                    routerLink="/loa/{{currentCompany?.sugarUuid}}" type="button">
                    <i aria-hidden="true" class="fa fa-list-alt icon-color"></i>
                    <span> LOAs</span>
                  </button>
                </div>
                <div *ngIf="hasDADAdminButton()" class="col-2">
                  <button
                    class="btn btn-outline-primary "
                    name="dad_admin_link"
                    routerLink="/dad-admin/{{companyUniqid}}" type="button">
                    <i aria-hidden="true" class="fa fa-file icon-color"></i>
                    <span> DAD Admin</span>
                  </button>
                </div>
              </div>
            </p-panel>
          </div>
          <div *ngIf="isShowPage()">
            <div>
              <p-panel [toggleable]="true">
                <ng-template pTemplate="header">
                  <span class="filter-title p-panel-title"><i class="fa fa-list"></i> Company Information</span>
                </ng-template>
                <ul style="padding-left: 17px; margin-bottom: 0; margin-top: 10px;">
                  <li *ngIf="selectedSalesforceAccountName!=null">
                    Salesforce Account:  {{ selectedSalesforceAccountName }}
                  </li>
                  <li *ngIf="currentCompany.sugarShortname">Shortname:  {{ currentCompany.sugarShortname }}</li>
                  <li *ngIf="currentCompany.activeUsers">Active
                    users:  {{ currentCompany.activeUsers + '/' + currentCompany.totalUsers }}
                  </li>
                  <li *ngIf="currentCompany.sugarMckayStatus">Mckay status:  {{ currentCompany.sugarMckayStatus }}</li>
                  <li *ngIf="currentCompany.sugarQuincyStatus">Quincy status:  {{ currentCompany.sugarQuincyStatus }}
                  </li>
                  <li *ngIf="currentCompany.ndaExecutionDate">NDA
                    execution:  {{ currentCompany.ndaExecutionDate| date : "MMM dd, y H:mm" }}
                  </li>
                  <li *ngIf="currentCompany.ndaExpirationDate">Expiration
                    date:  {{ currentCompany.ndaExpirationDate| date : "MMM dd, y H:mm" }}
                  </li>
                  <li *ngIf="currentCompany.createdAt">Created date:  {{ currentCompany.createdAt }}</li>
                  <li *ngIf="currentCompany.lastLogin">Last login:  {{ currentCompany.lastLogin | date : "MMM dd, y H:mm" }}</li>
                </ul>
              </p-panel>
            </div>
          </div>

          <form>
            <div>
              <div class="col-lg-6 col-md-12 pr-2">
                <h5 *ngIf="isAddPage()"><b>Company</b></h5>
                <div class="pl-4">
                  <div *ngIf="isAddPage() " class="form-group">
                    <label for="shortname_id">Salesforce account
                      <i class="fa fa-question-circle pull-right"
                         pTooltip="The account must be a 'Target' or 'Vendor' and have Send to Portal=True in Salesforce."
                         style="color: grey;"></i>
                      <span *ngIf="submitted && !selectedSalesforceAccount" class="alert"
                            style="font-weight: normal; color: red;">
                        <label>is required</label>
                      </span>
                    </label>
                    <div class="pl-2">
                      <p-dropdown [(ngModel)]="selectedSalesforceAccount"
                                  [filter]="true" [options]="salesforceAccountsDropdown"
                                  [placeholder]="accountDropdownPlaceHolder" [showClear]="true" id="shortname_id"
                                  name="selectedSalesforceAccount"></p-dropdown>
                    </div>
                  </div>

                  <div *ngIf="isEditPage() &&billingAccounts.length!==0" class="form-group ">
                    <ng-container *ngIf="hasMultipleBusinessUnits"><label>Business Units </label></ng-container>
                    <ng-container *ngIf="!hasMultipleBusinessUnits"><label>Business Unit</label></ng-container>
                    <div *ngFor="let item of billingAccounts">
                      <ng-container *roles="['ROLE_MCKAY_SUPER']">
                        <i (click)="deleteSelected( item.id )" aria-hidden="true"
                           class="fa fa-times-circle custom-delete-icon"
                           style="cursor: pointer"
                           title="Delete billing account">
                        </i></ng-container>
                      <span class="col-md-4">{{ item.name }}</span>
                    </div>
                  </div>
                  <div>
                    <p-checkbox *ngIf="isAddPage()" [(ngModel)]="isTimeSyncOnly" binary="true"
                                label="Precision Time Exchange view only" name="isTimeSyncOnly"
                                value="true"></p-checkbox>
                  </div>
                </div>
                <br>
                <h5 *ngIf="isAddPage()"><b>Primary contact</b>
                  <small class="form-text text-muted" style="font-size: 13px;">
                    Company default contact. A new Portal user will be created with a superadmin role and an email will
                    be sent to the below email address
                  </small>
                </h5>
                <div class="pl-4">
                  <div *ngIf="isAddPage()" class="form-group">
                    <label for="primary_contact_name_id">Name
                      <span *ngIf="submitted && primaryContactName.length === 0" class="alert"
                            id="primary_contact_name_required_alert"
                            style="font-weight: normal; color: red;">
                        is required
                      </span>
                    </label>
                    <div class="pl-2">
                      <input [(ngModel)]="primaryContactName"
                             [ngClass]="{ 'is-invalid': submitted && primaryContactName.length === 0 }"
                             class="form-control" id="primary_contact_name_id"
                             name="primaryContactName"
                             placeholder="Primary contact name"
                             type="text">
                    </div>
                  </div>
                  <div *ngIf="isAddPage()" class="form-group">
                    <label for="primary_contact_email_id">Email
                      <span *ngIf="existingEmail || (submitted && !validateEmail(primaryContactEmail))" class="alert"
                            style="font-weight: normal; color: red;">
                        <label *ngIf="existingEmail" id="primary_contact_email_already_exists_alert"></label>
                        <label *ngIf="!existingEmail && primaryContactEmail.length === 0"
                               id="primary_contact_email_required_alert">is required</label>
                        <label *ngIf="!existingEmail && primaryContactEmail.length > 0 && !validateEmail(primaryContactEmail)"
                               id="primary_contact_email_invalid_alert">is invalid</label>
                      </span>
                    </label>
                    <div class="pl-2">
                      <input (input)="clearExistingEmailError()"
                             [(ngModel)]="primaryContactEmail"
                             [ngClass]="{ 'is-invalid': existingEmail || submitted && (!validateEmail(primaryContactEmail) || primaryContactEmail.length === 0), 'text-danger': existingEmail }"
                             class="form-control"
                             id="primary_contact_email_id" name="primaryContactEmail"
                             placeholder="Primary contact email"
                             type="text">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-12 pr-2">
                <br>
                <div class="pl-4">
                  <div *ngIf="isAddPage()" class="form-group">
                    <label>Affiliation
                      <span *ngIf="submitted && !hasAffiliation()" class="alert"
                            id="affiliation_required_alert" style="font-weight: normal; color: red;">
                      At least one affiliation is required
                    </span>
                    </label>
                    <div class="pl-2">
                      <div class="custom-control custom-checkbox">
                        <p-checkbox [(ngModel)]="affiliationMckay" (ngModelChange)="check('mckay')"
                                    [ngClass]="{ 'is-invalid': submitted && !hasAffiliation() }" binary="true"
                                    label="Mckay Brothers" name="mckayBrothers"
                                    value="true"></p-checkbox>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <p-checkbox [(ngModel)]="affiliationQuincy" (ngModelChange)="check('quincy')"
                                    [ngClass]="{ 'is-invalid': submitted && !hasAffiliation() }" binary="true"
                                    label="Quincy Data" name="quincyData"
                                    value="true"></p-checkbox>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <p-checkbox [(ngModel)]="affiliationVendor" (ngModelChange)="check('vendor')"
                                    [ngClass]="{ 'is-invalid': submitted && !hasAffiliation() }" binary="true"
                                    label="Vendor" name="vendor"
                                    value="true"></p-checkbox>
                      </div>
                      <small class="form-text text-muted" style="font-size: 13px;">
                        Will receive emails from McKay or Quincy. This is automatically overridden by Salesforce
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="form-group col-md-12">
            <div *ngIf="isEditPage()" class="form-group">
              <h5 class="p-2">Salesforce account
                <label> <i class="fa fa-question-circle pull-left"
                           pTooltip="The account must be a 'Target' or 'Vendor' and have Send to Portal=True in Salesforce."
                           style="color: grey;"></i>
                  <span *ngIf="submitted && !selectedSalesforceAccount" class="alert"
                        style="font-weight: normal; color: red;">
                        <label>is required</label>
                </span> </label>
              </h5>
              <div>
                <p-dropdown [(ngModel)]="selectedSalesforceAccount"
                            [filter]="true" [options]="salesforceAccountsDropdown"
                            [placeholder]="accountDropdownPlaceHolder" [showClear]="true"
                            name="selectedSalesforceAccount"></p-dropdown>
              </div>
            </div>
          </div>
          <div *ngIf="isEditPage()" class="custom-control" style="padding-left: 15px;">
            <p-checkbox [(ngModel)]="isTimeSyncOnly" binary="true"
                        label="Precision Time Exchange view only" name="isTimeSyncOnly" value="true"></p-checkbox>
          </div>
          <br>
          <div *ngIf="(isEditPage() || isShowPage()) && dadConfigsNames.length > 0" [class.col-md-12]="isEditPage()"
               class="form-group ">
            <p-panel [toggleable]="true">
              <ng-template pTemplate="header">
                <span class="filter-title p-panel-title"><i class="fa fa-list"></i> DAD Reporting</span>
              </ng-template>
              <p-table [value]="dadConfigsNames">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Exchange</th>
                    <th>Exempt</th>
                    <th>Internal use</th>
                    <th>Report as subvendor</th>
                    <th>Self-reporting</th>
                    <th>Note</th>
                  </tr>
                </ng-template>
                <ng-template let-dadConfigName pTemplate="body">
                  <tr [ngClass]="{'disabled': disableDadInput(dadConfigName['exchangeNameInTitle'])}">
                    <td><b>{{ dadConfigName['exchangeNameInTitle'] }}</b>
                      <ng-container
                        *ngIf="getNgModel(dadConfigName['exchangeNameInTitle']).vanId && dadConfigName['exchangeNameInTitle'] === 'TheICE'">
                        (VAN ID: {{ getNgModel(dadConfigName['exchangeNameInTitle']).vanId }})
                      </ng-container>
                    </td>
                    <td class="custom-checkbox">
                      <div class="pl-10" id="checkbox-container">
                        <div class="custom-control custom-checkbox">
                          <input (change)="changeDadCompanySettings(dadConfigName['exchangeNameInTitle'])"
                                 [(ngModel)]="getNgModel(dadConfigName['exchangeNameInTitle']).exempt"
                                 [disabled]="disableDadInput(dadConfigName['exchangeNameInTitle']) || !dadConfigName['canExempt']"
                                 class="custom-control-input" id="{{dadConfigName['exchangeNameInTitle'] + 'exempt'}}"
                                 type="checkbox">
                          <label class="custom-control-label"
                                 for="{{dadConfigName['exchangeNameInTitle'] + 'exempt'}}"></label>
                        </div>
                      </div>
                    </td>
                    <td class="custom-checkbox">
                      <div class="pl-10">
                        <div class="custom-control custom-checkbox">
                          <input (change)="changeDadCompanySettings(dadConfigName['exchangeNameInTitle'])"
                                 [(ngModel)]="getNgModel(dadConfigName['exchangeNameInTitle']).internalUse"
                                 [disabled]="disableDadInput(dadConfigName['exchangeNameInTitle'])"
                                 class="custom-control-input"
                                 id="{{dadConfigName['exchangeNameInTitle'] + 'internalUse'}}" type="checkbox">
                          <label class="custom-control-label"
                                 for="{{dadConfigName['exchangeNameInTitle'] + 'internalUse'}}"></label>
                        </div>
                      </div>
                    </td>
                    <td class="custom-checkbox">
                      <div class="pl-10">
                        <div class="custom-control custom-checkbox">
                          <input (change)="changeDadCompanySettings(dadConfigName['exchangeNameInTitle'])"
                                 [(ngModel)]="getNgModel(dadConfigName['exchangeNameInTitle']).reportAsSubvendor"
                                 [disabled]="disableDadInput(dadConfigName['exchangeNameInTitle']) || !dadConfigName['canReportAsSubvendor']"
                                 class="custom-control-input"
                                 id="{{dadConfigName['exchangeNameInTitle'] + 'reportAsSubvendor'}}" type="checkbox">
                          <label class="custom-control-label"
                                 for="{{dadConfigName['exchangeNameInTitle'] + 'reportAsSubvendor'}}"></label>
                        </div>
                      </div>
                    </td>
                    <td class="custom-checkbox">
                      <div class="pl-10">
                        <div class="custom-control custom-checkbox">
                          <input (change)="changeDadCompanySettings(dadConfigName['exchangeNameInTitle'])"
                                 [(ngModel)]="getNgModel(dadConfigName['exchangeNameInTitle']).selfReport"
                                 [disabled]="disableDadInput(dadConfigName['exchangeNameInTitle']) || !dadConfigName['canSelfReport']"
                                 class="custom-control-input"
                                 id="{{dadConfigName['exchangeNameInTitle'] + 'selfReport'}}" type="checkbox">
                          <label class="custom-control-label"
                                 for="{{dadConfigName['exchangeNameInTitle'] + 'selfReport'}}"></label>
                        </div>
                      </div>
                    </td>
                    <td>
                      <input (change)="changeDadCompanySettings(dadConfigName['exchangeNameInTitle'])"
                             *ngIf="isEditPage()"
                             [(ngModel)]="getNgModel(dadConfigName['exchangeNameInTitle']).note"
                             [disabled]="disableDadInput(dadConfigName['exchangeNameInTitle'])" type="text">
                      <div *ngIf="isShowPage()">{{ getNgModel(dadConfigName['exchangeNameInTitle']).note }}</div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-panel>
          </div>
          <div class="row col-12 sd-flex justify-content-end buttons-margin-left pr-0">
            <div class="col-6 pl-0">
              <button (click)="activateOrDeactivateAwsAccess()" *ngIf="isShowPage() ||isEditPage()"
                      class="btn btn-outline-warning no-padding-button" name="aws_access_link" type="button">
                <i [ngClass]="this.currentCompany.awsPacketCounterAccess ? 'fa-times-circle' : 'fa-check-circle'"
                   aria-hidden="true" class="fa icon-color"></i>
                <span *ngIf="this.currentCompany.awsPacketCounterAccess"> Deactivate Access to AWS Services</span>
                <span *ngIf="!this.currentCompany.awsPacketCounterAccess"> Activate Access to AWS</span>
              </button>
            </div>
            <div class="col-6 pr-0 pl-0">
              <div class="pull-right">
                <button class="btn btn-outline-primary mr-2" id="back_to_list_button"
                        routerLink="/{{getUserCurrent().company?.uniqid}}/company"
                        type="button">
                  <i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>
                  Back to list
                </button>
                <button *ngIf="isShowPage() && canAddOrEditClients()"
                        class="btn btn-outline-primary "
                        id="edit_button"
                        routerLink="/{{getUserCurrent().company?.uniqid}}/company/{{currentCompany?.uniqid}}/edit"
                        type="button">
                  <i aria-hidden="true" class="fa fa-edit pr-2"></i>
                  Edit
                </button>
                <button (click)="onSubmit()" *ngIf="isEditPage()" class="btn btn-outline-primary" id="save_button">Save
                </button>
                <button (click)="onSubmit()" *ngIf="isAddPage()" class="btn btn-outline-primary" id="add_button">Add
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
